export const SUPPORTED_FORMATS = ['MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD'];

export const DEFAULT_FORMAT = SUPPORTED_FORMATS[0];

export const NATIVE_FORMAT = 'YYYY-MM-DD';

export const YEARS_RANGE = 100;

export const DIVIDER = '/';

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const weekdays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const counterConfig = {
  MONTH: { id: 'month', min: 1, max: 12, placeholder: 'MM' },
  DAY: { id: 'day', min: 1, max: 31, placeholder: 'DD' },
  YEAR: { id: 'year', min: 0, max: 9999, placeholder: 'YYYY' },
};

export const valRange = {
  year: { min: 1900, max: 2099 },
};

export const BUTTON_LABEL_DONE = 'Done';
export const BUTTON_LABEL_CANCEL = 'Cancel';
export const CALENDAR_LABEL_TODAY = 'Today';

export const MOBILE_DEVICE_INTERACTION_TIMEOUT_MS = 150;
